import React, { useState } from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";
import { useNavigate } from "react-router-dom";

const insights = [
  {
    id: 1,
    title: "Today\'s Market Insight",
    content: "Tech sector showing strong momentum with AI-driven stocks leading gains. NVDA and MSFT both up over 2% as institutional investors increase positions ahead of Q1 earnings. Consider reviewing your tech allocation — your portfolio is currently 18% tech vs. the recommended 20-25% for your growth profile.",
    tags: ["Technology", "Portfolio", "Earnings"],
    confidence: 87,
    timestamp: "Updated 15 min ago",
  },
];

export default function AIInsightCard() {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const insight = insights?.[0];

  return (
    <section
      className="rounded-xl p-4 md:p-5"
      style={{
        background: "var(--color-primary)",
        border: "1px solid rgba(133,113,77,0.25)",
      }}
      aria-label="Daily AI Insight"
    >
      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div
            className="w-8 h-8 rounded-lg flex items-center justify-center"
            style={{ background: "rgba(133,113,77,0.2)" }}
          >
            <Icon name="Sparkles" size={16} color="var(--color-accent)" strokeWidth={1.75} />
          </div>
          <div>
            <p className="font-caption font-semibold text-sm text-white">{insight?.title}</p>
            <p className="font-caption text-xs" style={{ color: "rgba(255,255,255,0.5)" }}>
              WIN AI · {insight?.timestamp}
            </p>
          </div>
        </div>
        <div
          className="flex items-center gap-1 px-2 py-1 rounded-full"
          style={{ background: "rgba(133,113,77,0.15)" }}
        >
          <Icon name="Activity" size={11} color="var(--color-accent)" />
          <span className="font-data text-xs font-semibold" style={{ color: "var(--color-accent)" }}>
            {insight?.confidence}% confidence
          </span>
        </div>
      </div>
      {/* Content */}
      <p
        className={`font-body text-sm leading-relaxed mb-3 ${!expanded ? "line-clamp-3" : ""}`}
        style={{ color: "rgba(255,255,255,0.85)" }}
      >
        {insight?.content}
      </p>
      {/* Tags */}
      <div className="flex flex-wrap gap-1.5 mb-4">
        {insight?.tags?.map((tag) => (
          <span
            key={tag}
            className="font-caption text-xs px-2 py-0.5 rounded-full"
            style={{ background: "rgba(133,113,77,0.15)", color: "var(--color-accent)" }}
          >
            {tag}
          </span>
        ))}
      </div>
      {/* Actions */}
      <div className="flex gap-2 flex-wrap">
        <Button
          variant="ghost"
          size="xs"
          iconName={expanded ? "ChevronUp" : "ChevronDown"}
          iconPosition="right"
          iconSize={13}
          onClick={() => setExpanded(!expanded)}
          className="text-white/70 hover:text-white"
        >
          {expanded ? "Show less" : "Read more"}
        </Button>
        <Button
          variant="outline"
          size="xs"
          iconName="MessageSquare"
          iconPosition="left"
          iconSize={13}
          onClick={() => navigate("/community-hub")}
          className="border-white/20 text-white/80 hover:text-white"
        >
          Ask WIN AI
        </Button>
      </div>
    </section>
  );
}